import * as types from '../../actions/ActionTypes';
import { SegmentsAvailable } from '../../constants/index';

const INITIAL_STATE = {
    initialized: false,
    polyline: null,
    lineChart: -1,
    draggingMarker: false,
    segmentStartPointIndex: -1,
    segmentEndPointIndex: -1,
    tempStart: -1,
    tempEnd: -1,
    selectedTab: SegmentsAvailable.CREATED_BY_ME,
    activity: null,
    error: null
};

const updateSegment = (state, action) => {
    return {
        ...state,
        ...action.data,
        initialized: true
    };
};

const formatData = (data) => {
    return data.map((entry) => {
        return {
            ...entry,
            lat: entry.latitude,
            lon: entry.longitude
        };
    });
};

const receivePolyline = (state, action) => {
    return {
        ...state,
        error: null,
        polyline: formatData(action.data.polyline)
    };
};

const receivePolylineFail = (state, { error }) => {
    return {
        ...state,
        error
    };
};

const receiveBadiuConvertPolyline = (state, action) => {
    return {
        ...state,
        polyline: formatData(action.polyline)
    };
};

const selectTab = (state, action) => {
    return {
        ...state,
        selectedTab: action.selectedTab
    };
};

const resetPage = () => {
    return INITIAL_STATE;
};

const segmentActivityFetched = (state, action) => {
    return {
        ...state,
        activity: action.activity
    };
};

const handlers = {
    [types.UPDATE_SEGMENT]: updateSegment.bind(this),
    [types.RECEIVE_ACTIVITY_POLYLINE_FOR_SEGMENT]: receivePolyline,
    [types.REQUEST_ACTIVITY_POLYLINE_FOR_SEGMENT_FAIL]: receivePolylineFail,
    [types.RECEIVE_ACTIVITY_POLYLINE_FOR_BAIDU_CONVERT]: receiveBadiuConvertPolyline,
    [types.SELECT_SEGMENTS_TAB]: selectTab,
    [types.RESET_SEGMENT_PAGE]: resetPage,
    [types.RECEIVE_SEGMENT_ACTIVITY]: segmentActivityFetched
};

export const getSegmentPage = (state) => state.segmentPage;
export const getPolyline = (state) => state.segmentPage.polyline;
export const getSegmentActivity = (state) => state.segmentPage.activity;
export const getSegmentError = (state) => state.segmentPage.error;

export default function segmentPage(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
